import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import { useEffect, useRef } from 'react';

const useStyles = makeStyles(() => ({
  mediaUnavailableWrapper: {
    width: '100%',
    height: '100%',
  },
}));

interface MediaUnavailableProps {
  text?: string;
}

const MediaUnavailable: React.FC<MediaUnavailableProps> = ({ text = 'Media Unavailable' }) => {
  const classes = useStyles();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const theme = useTheme();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext('2d');
    if (!context) return;

    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    context.fillStyle = 'black';
    context.fillRect(0, 0, canvas.width, canvas.height);

    context.font = '24px Arial';
    context.fillStyle = theme.palette.secondary.main;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, canvas.width / 2, canvas.height / 2);
  }, [text, theme.palette.secondary.main]);

  return <canvas ref={canvasRef} className={classes.mediaUnavailableWrapper} />;
};

export default MediaUnavailable;
